// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescribersRequestModel {
    static getAttributeTypeMap() {
        return PrescribersRequestModel.attributeTypeMap;
    }
}
PrescribersRequestModel.discriminator = undefined;
PrescribersRequestModel.additionalProperties = false;
PrescribersRequestModel.attributeTypeMap = [
    {
        "name": "prescriberIds",
        "baseName": "prescriberIds",
        "type": ""
    },
];
//# sourceMappingURL=prescribersRequestModel.js.map